import React, { Component } from "react";
import { PaystackButton } from "react-paystack";
import { getPSPublicKey } from "../../services/authService";
import { formatNumber, generateRandomString } from "../../services/util";

class Paystack extends Component {
  state = {
    publicKey: getPSPublicKey(),
    className: "payment-button",
    onSuccess: (reference) => this.handlePaystackSuccessAction(reference),
    onClose: this.handlePaystackCloseAction,
  };

  componentDidMount() {
    const text = <span>Pay NGN {formatNumber(this.props.amount)} With Paystack </span>;
    const reference = `smartciti-${this.props.invoice._id}-${generateRandomString(5)}`;
    const email = this.props.email;
    const amount = this.calculateFinalAmount(this.props.amount) + "00";

    this.setState({ reference, email, amount, text });
  }

  calculateFinalAmount = (amount) => {
    return parseInt(amount + 100);
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      text: <span>Pay NGN {formatNumber(nextProps.amount)} With Paystack </span>,
      amount: this.calculateFinalAmount(nextProps.amount) + "00",
    });
  }

  handlePaystackSuccessAction = async (reference) => {
    this.props.verifyPayment();
    this.props.callBackFromParent();
  };

  handlePaystackCloseAction = () => {};

  render() {
    return <PaystackButton {...this.state} />;
  }
}

export default Paystack;
